import { useMemo } from 'react';
import { FieldPath } from 'react-hook-form';
import * as yup from 'yup';
import { companyFields } from '../../../schemas/Company.schema';
import { schemaToFormFields } from '../../../util/schema-utils';
import { ICompanyViewModel } from '../../../view-models/company.view-model';
import { IFormField } from '../../../view-models/form.view-model';
import { companyFormFields, useCompanyFields } from '../../Finance2/Forms/CompanyFormUtils';
import { filterAndSortByPreferences } from '../utils/filterAndSortByPreferences';

export function useCompanyListsFields(fieldsToShow?: FieldPath<ICompanyViewModel>[]) {
  const newFieldsToShow = fieldsToShow?.map((field) =>
    field === '_viewModel.totalRaised' ? 'raisedToDate' : field
  );
  const allListsFields = useCompanyFields({
    fields: newFieldsToShow as FieldPath<ICompanyViewModel>[],
    variant: 'form-inline',
    customFields: 'none',
  });

  return useMemo(() => {
    if (!fieldsToShow?.length) {
      return allListsFields;
    }
    return filterAndSortByPreferences(allListsFields, fieldsToShow);
  }, [allListsFields, fieldsToShow]);
}

export function getCompanyListsFieldsFromSchema() {
  const formFields = schemaToFormFields(
    yup.object({
      ...companyFields(),
      ...companyFormFields(),
    }),
    [
      'assignee',
      'latestInvestors',
      'latestLeadInvestor',
      'sectorId',
      '_viewModel.lastFunding',
      'foundedDate',
      'latestFundingDate',
      '_viewModel.primaryLocation',
      '_viewModel.totalRaised',
    ]
  );
  return formFields.map(transformCompanyFormFieldForLists);
}

export function transformCompanyFormFieldForLists(field: IFormField<unknown>) {
  const newField = { ...field };
  if (newField.key === '_viewModel.primaryLocation') {
    newField.label = 'Primary Location';
  }
  return newField;
}
